import React from 'react';
import { useUserData, FrequencyOption } from '@/context/UserDataContext';
import { getMeatFrequencyOptions } from '../../shared/constants';
import { FormSection } from '../../shared/FormSection';
import AnimatedSelectionGroup from '../../AnimatedSelectionGroup';

interface MeatConsumptionProps {
  error?: string;
  onComplete?: () => void;
}

const MeatConsumption: React.FC<MeatConsumptionProps> = ({ error, onComplete }) => {
  const { userData, setUserData } = useUserData();
  const meatOptions = getMeatFrequencyOptions();

  const handleMeatConsumptionChange = (value: FrequencyOption) => {
    setUserData(prev => ({ ...prev, meatConsumption: value }));
  };

  return (
    <FormSection
      question="How often do you eat red meat?"
      helperText="This helps us assess your protein intake and the potential need to supplement with vitamins or minerals commonly found in red meats."
      error={error}
    >
      <AnimatedSelectionGroup
        options={meatOptions}
        value={userData.meatConsumption}
        onChange={handleMeatConsumptionChange}
        name="meat-consumption"
        onComplete={onComplete}
      />
    </FormSection>
  );
};

export default MeatConsumption; 